/**
 * @author Yaochao
 * @date 2022/3/18 17:30
 * @description
 */
class MixedMessageParser {

    /**
     * 给服务端发送文本时，需要先解析混合文本
     * @param message
     */
    static parser(message) {
        let pattern = /(\[([^\[\]]+)\])|(@[^\[\]\s]+)/g;
        let result = pattern.exec(message);
        let arr = [];
        let remainContent = message;
        while (result != null) {
            let matItem = result[0];
            let index = remainContent.indexOf(matItem);
            if (index > 0) {
                arr.push({
                    subtype: 0,
                    text: remainContent.substring(0, index)
                });

            }
            arr.push({
                subtype: matItem.startsWith('@') ? 1 : 2,
                text: matItem
            });
            remainContent = remainContent.substring(index + matItem.length);
            result = pattern.exec(message);
        }
        if (remainContent.length > 0) {
            arr.push({
                subtype: 0,
                text: remainContent
            })
        }
        return arr;
    }

    /**
     * 去掉a标签和br标签
     * @param message
     * @returns {*}
     */
    static html2Text(message) {
        if (message) {
            // message = message.replace('/<br />/gm', '');
            message = message.replace(new RegExp('<br/>', 'gm'), '\n');
            let pattern = /<a .*?href=['\"](.*?)['\"].*?>(.*?)<\/a>/;
            let result = pattern.exec(message);
            while (result != null) {
                message = message.replace(result[0], result[1]);
                result = pattern.exec(message);
            }
        }
        return message;
    }

    /**
     * 获取消息里面文本格式的表情
     * @param message
     */
    static getEmojiText(message) {
        let pattern = /(\[([^\[\]]+)\])/g;
        let result = pattern.exec(message);
        let arr = [];
        if (result) {
            do {
                if (arr.indexOf(result[0]) == -1) {
                    arr.push(result[0])
                }
            } while (result = pattern.exec(message))
        }
        return arr;
    }

    /**
     * 将图片的表情转成文本
     * @param message
     */
    static parserEmojiToText(message) {
        let pattern = /<img class="zkEmoji" alt="([\S]+)".*?\/>/g;
        let result = pattern.exec(message);
        let emap = [];
        if (result) {
            do {
                emap.push({
                    text: result[1],
                    imgTag: result[0]
                })
            } while (result = pattern.exec(message))
        }
        emap.forEach((item) => {
            message = message.replace(item.imgTag, `[${item.text}]`)
        });
        return message;
    }
}

export default MixedMessageParser